import React from 'react';
import { bool, func, string } from 'prop-types';
import moment from 'moment';
import CustomMonthRangePicker from '../../shared/CustomMonthRangePicker';
import LightTooltip from '../../shared/LightTooltip';

const ReportsPeriod = ({ handleDateChange, from, to, isDateError = false }) => {
  const tooltipContent =
    'All targets within a request that had an active status during the selected calendar month(s) are included in a report. For months in progress, data will be included up to and including the current day.';
  let isError = false;
  if (isDateError) {
    isError = !from || !to;
  }
  const _handleDateChange = (key, value) => {
    const date = value ? moment(value).format('MMM-YYYY') : undefined;
    handleDateChange(key, date);
  };
  return (
    <div className="de--reports--period--col">
      <div className="de--reports--card">
        <div className="de--reports--card--title">
          <h4>
            <span>Time Period</span>
            <LightTooltip title={tooltipContent} />
          </h4>
        </div>
        <div className="de--reports--card--body">
          <CustomMonthRangePicker
            handleDateChange={_handleDateChange}
            isError={isDateError}
          />
          {isError && (
            <div className="displayError">
              Month start and end dates are required.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ReportsPeriod.propTypes = {
  handleDateChange: func,
  from: string,
  to: string,
  isDateError: bool,
};

export default ReportsPeriod;
